import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectAuth } from '../../../redux/authSlice'

// SecureRoute fetches a new MSAL token on every URL change, so keying fetches on the token
// reloads them each time a filter, tab or row moves the URL. Gate once; useRequest reads the current token.
export function useAuthReady() {
  const auth = useSelector(selectAuth)
  const [ready, setReady] = useState(false)
  useEffect(() => {
    if (auth.fromPageChange && auth.accessToken) setReady(true)
  }, [auth.fromPageChange, auth.accessToken])
  return ready
}
